"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'マチゼロ',
    organizationId: 'shokufesnLG1sOTbvaLG',
    applicationKey: 'machizero',
    applicationType: 'organization',
    artistId: undefined,
    ios: {
        bundleId: 'jp.machizero',
        appId: '',
    },
    android: {
        bundleId: 'jp.machizero',
    },
    deeplinkUrl: 'https://app.machizero.jp',
    helpUrl: 'https://help.utoniq.com/ja/collections/6304346',
    storagePath: 'shokufes',
    dynamicLinkPrefix: 'shokufes',
    deeplinkProd: 'app.machizero.jp',
    custom: {
        modules: {
            trade: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            resale: true,
            preSale: true,
            event: true,
            cart: true,
            pickup: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'events', 'pickup', 'myProfile'],
        artistTabs: ['home', 'store', 'posts'],
    },
});
